import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0009 0.833984L18.3729 4.65718L17.3439 6.37216L17.0009 6.16636V8.00017H7.0009V6.16636L6.6579 6.37216L5.62891 4.65718L12.0009 0.833984ZM11 3.99805V6.00195H13.0039V3.99805H11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 10H2V22H8V15H16V22H22V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 17V22H14V17H10Z"}}]};

const Building2Filled = Vue.extend<IconProps>({
  name: 'Building2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'building-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Building2Filled;
